import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=20222977"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"
import style0 from "./Face.vue?vue&type=style&index=0&id=20222977&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports